export const MiscActionTypes = {
    SET_APP_INIT: "SET_APP_INIT",
    SET_SINGLE_VIDEO: "SET_SINGLE_VIDEO",
    SET_CAMPAIGN_ANSWERED: "SET_CAMPAIGN_ANSWERED",
}